export const COMMENTS = '/comments'
export const SIGN_IN = '/signin'
export const SIGN_UP = '/signup'
export const ACCOUNT = '/account'
export const PASSWORD_RESET = '/password-reset'